module.exports = __webpack_public_path__ + "img/zizhi10.b49818b0.jpg";